import { useEffect, useState } from "react"
import httpClient from "../../HTTPService"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import moment from "moment/moment"

function ReviewList() {
    const [reviewList, setReviewlist] = useState([])
    const [totalCount, setTotalCount] = useState(0)
    const [searchtext, setsearchtext] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [getLimit, setLimit] = useState(10);
    const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(items.length / getLimit);
    const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
    const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));
    // const [totalCount, setTotalCount] = useState(0)
    const [deleteUser, setDeleteUser] = useState();

    const [activelsitiID, setActivelistID] = useState('')

    const [ReviewDetails, setReviewDetails] = useState([])
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    // State to manage the toggle status

    // Toggle function
    const handleToggle = () => {

    };
    const searchtxt = () => {
        getReviewList(searchtext, 1, getLimit);
    }
    //
    //pagination

    const Pagination = ({ currentPage, totalPages, onPageChange }) => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        console.log(currentPage, 'current pages...')
        return (
            <div className="pagination">
                {currentPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                )}
                {startPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(1)}>
                        1
                    </button>
                )}
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                {pages.slice(startPage - 1, endPage).map(page => (
                    <button
                        key={page}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                {endPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )}
                {currentPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        );
    };
    ///
    const updatestatus = (id, status) => {
        // console.log(data, 'data...')
        try {
            httpClient.post('/admin/reviews-status-change', {
                id: id,
                status: status
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }).then((res) => {
                if (res.status === 200) {
                    fetchReviewDetails(activelsitiID)
                }
            })

            // if (result.status === 200) {
            //     console.log(result.data.data, 'data..')
            //     setTotalCount(result?.data.total_count)
            //     setReviewlist(result?.data?.data)
            // }

        } catch (error) {
            //   toast.error(error.message)
        }
    };
    useEffect(() => {
        getReviewList(searchtext, currentPage, getLimit)
    }, [getLimit, currentPage])
    const closeBtn = () => {
        document.getElementById('modalpop').classList.remove('open')
    }
    const yesDelete = async () => {
        try {
            const result = await httpClient.post('/admin/reviews/delete', { id: deleteUser }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            console.log(result.data);

            if (result.data.status == true) {
                toast.success("Comment Delete Successfully!")
                fetchReviewDetails(activelsitiID)
                // getUser();
                closeBtn();
            }
            if (result.data.status == false) {
                toast.error(result.data.message);
                closeBtn();
            }
            // if(result.data.data.length === 0){
            //  toast.error("Something went worng")
            //  getUser();
            //  closeBtn();
            // }
        } catch (error) {
            toast.error(error.message)
        }

    }
    const getReviewList = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post('/admin/reviews-list', {
                search_name, offset: pagecount, limit: limit
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                console.log(result.data.data, 'data..')
                setTotalCount(result?.data.total_count)
                setReviewlist(result?.data?.data)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }
    // switch button
    // debounce function to limit the number of API calss
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }
    // search handler function
    const searchHandler = debounce((query) => {
        setsearchtext(query);
        getReviewList(query, 1, getLimit);
    }, 2000)

    const fetchReviewDetails = async (id) => {
        let _fetchmemberdetails = await httpClient.post('/admin/reviews-details', {
            id: id
        }, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        if (_fetchmemberdetails?.status) {
            setReviewDetails(_fetchmemberdetails?.data?.data)
            //   calcualte_totalpayamount_details(_fetchmemberdetails?.data?.data)
        }
    }
    const deleteBtn = (id) => {
        // setBlockConfirm(data)
        setDeleteUser(id)
        document.getElementById('modalpop').classList.add('open')
    }


    return (

        <>
            <div class="search-box">
                <div class="searchtct">

                    <i class="fa fa-search" aria-hidden="true"></i>
                    <input type="text" name="text" placeholder="Search..."
                        onChange={(val) => searchHandler(val.target.value)}

                    />
                    {/* <button type='button' className='searchBtn' onClick={searchtxt} >Search</button> */}


                </div>

            </div>
            <h4>Total Review : {totalCount}</h4>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>SL NO</th>
                                    <th> Service Pro Name & ID</th>
                                    <th>Service Sub Cat Name</th>
                                    <th>Average Rating</th>
                                    <th>Status</th>

                                    <th>View Details</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    reviewList?.map((item, index) => {
                                        const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                        return (
                                            <>
                                                <tr>
                                                    <td>{serialNumber}</td>
                                                    <td>
                                                        <div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column'
                                                        }}>
                                                            <p style={{
                                                                padding: 0,
                                                                margin: 0
                                                            }}>{item?.user_name} </p>
                                                            <p> {item?.user_referral_code}</p>
                                                        </div>


                                                    </td>
                                                    <td>{item?.sub_category}</td>
                                                    <td >
                                                        {item?.avg_review}<span
                                                            // key={}
                                                            className='star filled'
                                                        //   onClick={() => handleClick(index + 1)}
                                                        >
                                                            ★
                                                        </span>

                                                    </td>
                                                    <td>

                                                        <p style={{
                                                            color: item?.profile_status == 1 ? 'black' : item?.profile_status == 3 ? 'red' : 'black'
                                                        }}>
                                                            {
                                                                item?.profile_status == 1 ? 'Active' : item?.profile_status == 2 ? 'Expired' : item?.profile_status == 3 ? 'Disabled' : ''
                                                            }
                                                        </p>

                                                    </td>
                                                    <td>

                                                        <div className='table-column' style={{
                                                            flexDirection: 'column',
                                                            display: 'flex'
                                                        }}>
                                                            <i
                                                                onClick={() => {
                                                                    setActivelistID(item?.id)
                                                                    fetchReviewDetails(item?.id)
                                                                }}
                                                                data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                                                                aria-hidden="true"
                                                                // onClick={() => navigate(`/profile-request-details/${item?.id}`)}
                                                                class="fa fa-eye" ></i>
                                                            <p style={{
                                                                color: 'red'
                                                            }}>{item?.reviews_count}</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <div className='nodata-found-div'>
                            {
                                reviewList?.length == 0 ?
                                    <p>No Data Found</p>
                                    //  <img 
                                    //  className='table-image'
                                    //  src={require('../../assets/OIP.png')}/>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="tablepgntn">
                <p>Show <select value={getLimit} onChange={(val) => {
                    setLimit(val.target.value);
                    setCurrentPage(1)
                }}>
                    <option>10</option>
                    <option>20</option>
                    <option>30</option>
                    <option>40</option>
                    <option>50</option>
                </select> Entries</p>
                <ul>

                </ul>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>
            <div
                class="offcanvas offcanvas-end offcanvas-fullscreen"
                style={{ width: '100vw', maxWidth: '100vw', height: '100vh' }}
                tabIndex="-1"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title" id="offcanvasRightLabel">Details</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

                </div>
                <div style={{
                    paddingLeft: 20
                }}>
                    <h6>User Comment : {ReviewDetails?.length}</h6>
                    {/* <h6>Member ID: {currentmemberdetails?.user_referral_code}</h6> */}
                </div>

                <div class="offcanvas-body ">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>SL NO</th>

                                            <th>
                                                User Name & ID

                                            </th>
                                            <th>Contact</th>
                                            <th>User Coment</th>
                                            <th>Rating</th>
                                            <th>Date & Time</th>
                                            <th>Disabled</th>
                                            <th>Action</th>


                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            ReviewDetails?.map((item, index) => {
                                                // const serialNumber = (currentPage - 1) * getLimit + index + 1;

                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <div style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column'
                                                                }}>
                                                                    <p> {item?.user?.name} </p>
                                                                    <p> {item?.user?.user_referral_code}</p>
                                                                </div>


                                                            </td>
                                                            <td>{item?.user?.phone}</td>
                                                            <td >
                                                                {item?.comment}

                                                            </td>
                                                            <td>

                                                                {
                                                                    Array.from({ length: 5 }, (_, index) => (
                                                                        <span
                                                                            key={index}
                                                                            className={`star ${index < item?.rating ? 'filled' : ''}`}  >
                                                                            ★
                                                                        </span>
                                                                    ))
                                                                }

                                                            </td>
                                                            <td>
                                                                {moment(item?.created_at).format('DD-MM-YYYY hh:mm A')}
                                                            </td>
                                                            <td>

                                                                <div
                                                                    className={`switch ${item?.active == 1 ? 'on' : 'off'}`}
                                                                    onClick={() => updatestatus(item?.id, item?.active == 1 ? 0 : 1)}
                                                                    role="switch"
                                                                    aria-checked={item?.active}
                                                                    aria-label="Toggle switch"
                                                                >
                                                                    <div className="switch-handle" />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Link onClick={() => { deleteBtn(item?.id) }}><i class="fa fa-trash" style={{
                                                                    color: 'red'
                                                                }} aria-hidden="true"></i></Link>

                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })
                                        }

                                    </tbody>
                                </table>
                                <div className='nodata-found-div'>
                                    {
                                        ReviewDetails?.length == 0 ?
                                            <p>No Data Found</p>
                                            //  <img 
                                            //  className='table-image'
                                            //  src={require('../../assets/OIP.png')}/>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div class="modalpop" id="modalpop" style={{
                zIndex: 9999
            }}>
                <div class="modalsbody">
                    <h3>Do You Want to Delete Comment ?</h3>
                    <div class="popBtn">
                        <button type="button" class="secussBtn"
                            onClick={() => {
                                yesDelete()
                            }}
                        // onClick={yesDelete}sssssssssssssssssssssssssssssssss

                        >
                            Yes
                        </button>
                        <button type="button" class="cancelBtn" onClick={closeBtn}>
                            No
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReviewList